import React from 'react';

import { Title, ButtonsGroup, Button } from 'components/commons';
import feedbackIcon from 'assets/svg/thanks-feedback.svg';

type AlreadyRegisteredMailProps = {
    email: string;
    onSubmit(): void;
}

const AlreadyRegisteredMailLayout: React.FC<AlreadyRegisteredMailProps> = ({ onSubmit, email }) => (
    <div className="screen password-screen">
        <div className="message-box text-left">
            <div>
                <img className="icon" src={feedbackIcon} />
            </div>

            <Title>proposta recebida</Title>

            <p className="text">
                Você já tem uma conta criada com a gente e pode acessar o seus dados com o seguinte e-mail
            </p>
            <p className="text bold">
                { email }
            </p>
            <p className="text">
                Se você não reconhece esse e-mail ou por algum motivo não tem mais acesso a ele, <a href="mailto:faleconosco@bizcapital.com.br">fala com a gente!</a>
            </p>

            <div className="mb-5 d-none d-sm-block" />
        </div>

        <ButtonsGroup>
            <Button
                label="continuar"
                onClick={onSubmit}
            />
        </ButtonsGroup>
    </div>
);

export default AlreadyRegisteredMailLayout;
